import styled from 'styled-components';

export const PasswordUpdatedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
